import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { FilterParameter, QueryParamsService } from 'common';
import { ClientQueryResult, ClientFilters } from '../client.data';
import { ClientListFilterDialogComponent } from '../client-list-filter-dialog/client-list-filter-dialog.component';
import { ClientFilterService } from '../client-filter.services';
import { routerTransition } from '../../../shared/animations/router.animations';
import { UserPermissionService } from '../../../user/user-permission/user-permission.service';
import { readWrite } from '../../../user/user-permission/user-permission.data';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-client-list',
    templateUrl: './client-list.component.html',
    styleUrls: ['./client-list.component.scss'],
    animations: routerTransition,
    standalone: false
})
export class ClientListComponent implements OnInit {
  clientSecrets = {};

  filters: ClientFilters;
  activeFilters: FilterParameter[] = [];
  readWriteClient: boolean;

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private userPermissionService: UserPermissionService,
    private _clientFilterService: ClientFilterService,
    private queryParamsService: QueryParamsService) { }

  clientSecretSave(id: string, secret: string) {
    this.clientSecrets[id] = secret;
  }

  data: ClientListComponentData;

  ngOnInit() {
  this.route.data.pipe(untilDestroyed(this)).subscribe((it: ClientListComponentData) => this.data = it);
  this.route.queryParams.pipe(untilDestroyed(this)).subscribe(it => {
      this.queryParams = this.queryParamsService.init(it);
      this.activeFilters = this._clientFilterService.addFilterParameters(this.queryParams);
    });

    this.userPermissionService.granted([readWrite('admin-clients')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.readWriteClient = res);

    this.filters = new ClientFilters(this.queryParams);
    this.paginator.pageSize = this.queryParams.limit;
    this.paginator.pageIndex =  this.queryParams.skip / this.queryParams.limit;
  }

  activeFilterRemoved(activefilters: FilterParameter[]): void {
    if (!activefilters.length) return;
    activefilters.forEach(item => {
      this.filters.remove(item.id);
      this._clientFilterService.filter(this.filters);
    });
  }

  filterDialog() {
    ClientListFilterDialogComponent.show(this.dialog, this.queryParams)
      .subscribe(result => {
        if (result) {
          this.filters = result;
          this.paginator.firstPage();
          this._clientFilterService.filter(result);
        }
      });
  }

  sortData(sort: Sort) {
    this._clientFilterService.filter(this.filters, this.paginator, this.sort);
  }

  setPage(event: PageEvent) {
    this._clientFilterService.filter(this.filters, this.paginator, this.sort);
  }

  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  queryParams: any;

  @ViewChild(MatSort)
  sort: MatSort;

  tableColumns: string[] = [
    'name',
    'oidcAudience',
    'oidcLoginAllowed',
    'active',
    'actions'
  ];

}

export interface ClientListComponentData {
  clientQueryResult: ClientQueryResult;
}
